
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.457 8.762c.074-.192.143-.452.163-.753.027-.53-.109-1.276-.88-1.953.051-.347.051-.896-.262-1.442-.415-.723-1.224-1.212-2.409-1.457-.793-.166-1.835-.2-3.097-.105a40.076 40.076 0 00-5.16.275l-.91.105a1.639 1.639 0 00-.93-.286H4.611C3.72 3.146 3 3.85 3 4.712v6.117c0 .866.724 1.566 1.61 1.566h2.362c.279 0 .538-.068.767-.188.162.346.402.741.759 1.106.019.02.038.038.062.053 1.215.907 2.648 4.175 3.155 5.507-.05.414-.1 1.31.325 1.796.19.214.453.331.747.331.299 0 1.328-.068 1.971-.93.608-.82.643-2.048.1-3.651-.456-1.348-.499-1.946-.483-2.187.209.045.414.086.612.12h.003c.035.008.887.192 1.905.237 1.448.068 2.497-.177 3.11-.722.843-.75.742-1.706.49-2.315.218-.275.48-.723.504-1.295.016-.52-.162-1.02-.542-1.495zm-13.485 2.62H4.611a.558.558 0 01-.566-.55V4.717c0-.305.256-.55.566-.55h2.361c.314 0 .566.248.566.55v6.117c0 .304-.252.55-.566.55zm12.455.365c0 .004.136.211.182.493a.906.906 0 01-.313.881c-.74.655-2.87.505-4.058.249l-.05-.012a21.308 21.308 0 01-.674-.131.863.863 0 00-.844.146c-.515.445-.457 1.454.19 3.37.426 1.257.441 2.205.046 2.736-.333.448-.882.505-1.091.508-.093-.15-.12-.666-.05-1.091a.562.562 0 00-.024-.253c-.074-.191-1.773-4.716-3.512-6.056a3.164 3.164 0 01-.72-1.291c.047-.147.074-.305.074-.467V4.716c0-.113-.012-.226-.035-.332l.391-.045h.004c.023-.004 2.544-.32 5.033-.267h.054c1.173-.09 2.122-.064 2.823.083.867.18 1.44.497 1.703.944.275.464.124.942.112.987a.489.489 0 00.178.576c1.146.835.62 1.81.55 1.93a.486.486 0 00.07.614c.333.34.495.678.484 1.01-.016.492-.407.861-.434.884a.486.486 0 00-.089.647z","fill":"currentColor"}})])
          )
        }
      }
    